import React from "react";
import ReactDOM from "react-dom";
import "./styles/fonts.css";
import "./styles/index.css";
import "./styles/utilities.css";
import "./styles/utilities-grid.css";
import "./styles/utilities-flex-gap.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
